import { render } from "./smallBasket.vue?vue&type=template&id=a42f953a&scoped=true"
import script from "./smallBasket.vue?vue&type=script&lang=js"
export * from "./smallBasket.vue?vue&type=script&lang=js"

import "./smallBasket.vue?vue&type=style&index=0&id=a42f953a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a42f953a"]])

export default __exports__